import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN,
  enabled: !!process.env.GATSBY_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,
  integrations: [Sentry.browserTracingIntegration()],
});

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import type { GatsbyBrowser } from "gatsby";
import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import CategoryModal from "./src/components/category/modal";
import ErrorBoundary from "./src/components/error-boundary";
import { StatsigWrapper } from "./src/components/statsig/wrapper";
import TransactionModal from "./src/components/transaction/modal";
import { AuthProvider } from "./src/context/auth-provider";
import { CategoryModalProvider } from "./src/context/category-modal-provider";
import { TransactionModalProvider } from "./src/context/transaction-modal-provider";
import { TourProvider } from "./src/context/tour-provider";
import { UserPreferencesProvider } from "./src/context/user-preferences-provider";
import { SubscriptionWrapper } from "./src/utils/subscription-wrapper";
import "./src/styles/global.css";

dayjs.extend(isBetween);
dayjs.extend(duration);
dayjs.extend(timezone);
dayjs.extend(utc);

const queryClient = new QueryClient();

export const wrapRootElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
}) => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <UserPreferencesProvider>
          <AuthProvider>
            <StatsigWrapper>
              <SubscriptionWrapper>
                <TourProvider>
                  <CategoryModalProvider>
                    <TransactionModalProvider>
                      {element}
                      <TransactionModal />
                    </TransactionModalProvider>
                    <CategoryModal />
                  </CategoryModalProvider>
                </TourProvider>
              </SubscriptionWrapper>
            </StatsigWrapper>
          </AuthProvider>
        </UserPreferencesProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};
